/* eslint-disable react/no-danger */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CONSTANTS from '../../constants/index'
import {
  GOOGLE_LOGIN_PENDING,
  TWITTER_LOGIN_PENDING,
  FACEBOOK_LOGIN_PENDING,
} from '../../actions'
import {transNamespace} from '../../services/conf-utils'

export default class MoreDetails extends Component {
  constructor(props) {
    super(props)

    this.state = {
      error: false,
      firstName: '',
      lastName: '',
      email: '',
      firstNameError: '',
      lastNameError: '',
      hasNewsletterConsent: false,
      hasTermsConsent: false,
      termsConsentError: '',
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.hasTermsConsent !== prevState.hasTermsConsent) {
      this.consentValidate()
    }
  }

  firstNameHandler = (e) => {
    this.setState({
      firstName: e.target.value,
    })
  }

  lastNameHandler = (e) => {
    this.setState({
      lastName: e.target.value,
    })
  }

  emailHandler = (e) => {
    this.setState({
      email: e.target.value,
    })
  }

  newsletterConsentHandler = (e) => {
    this.setState({
      hasNewsletterConsent: e.target.checked,
    })
  }

  termsConsentHandler = (e) => {
    this.setState({
      hasTermsConsent: e.target.checked,
    })
  }

  consentValidate = () => {
    const { t } = this.props

    if (this.state.hasTermsConsent) {
      this.setState({ termsConsentError: '' })
    } else {
      this.setState({ termsConsentError: t('TERM_OF_USE_ERROR') })
    }
  }

  firstNameValidate = () => {
    if (this.state.firstName === '') {
      this.setState({
        firstNameError: this.props.t('FIRST_NAME_ERROR'),
        error: true,
      })
    } else {
      this.setState({
        firstNameError: '',
        error: false,
      })
    }
  }

  lastNameValidate = () => {
    if (this.state.lastName === '') {
      this.setState({
        lastNameError: this.props.t('LAST_NAME_ERROR'),
        error: true,
      })
    } else {
      this.setState({
        lastNameError: '',
        error: false,
      })
    }
  }

  completeLogin = (e) => {
    e.preventDefault()

    this.firstNameValidate()
    this.lastNameValidate()
    this.consentValidate()

    const { missingFields, clientId, provider, providerSecret, providerToken } = this.props
    const { firstName, lastName, email, hasTermsConsent, hasNewsletterConsent } = this.state
    let isValid = true
    let fields = []
    let payload = {}

    payload = {
      newsletter: hasNewsletterConsent,
      terms: hasTermsConsent,
      client_id: clientId,
      providerSecret,
      providerToken,
    }

    fields = missingFields.filter(field => field !== 'terms')

    // validate consent
    if (!hasTermsConsent) {
      isValid = false
    }

    // validate form
    fields.forEach(field => {
      if (this.state[`${field}`] === '') isValid = false
    })

    // combine provider obj with user inputs
    fields.forEach(field => {
      Object.assign(payload, { [`${field}`]: this.state[`${field}`] })
    })

    if (isValid) {
      switch (provider) {
        case 'twitter':
          this.props.handleAction(TWITTER_LOGIN_PENDING, payload)
          break
        case 'google_plus':
          this.props.handleAction(GOOGLE_LOGIN_PENDING, payload)
          break
        default:
          this.props.handleAction(FACEBOOK_LOGIN_PENDING, payload)
          break
      }
    }
  }

  generateLinkMarkup = (url, text) => {
    let markup = ''

    if (url && text) {
      markup = `<a class="xs-text-red cursor-pointer" href="${url}" target="_blank">${text}</a>`
    } else if (!url && text) {
      markup = text
    }

    return markup
  }

  generateSiteLocaleLink = (pageData, locale, key) => {
    const localeFormatted = locale.replace('-', '_')

    if (pageData && pageData.locales && pageData.locales[localeFormatted]) {
      if (pageData.locales[localeFormatted][key]) {
        return pageData.locales[localeFormatted][key]
      }
    } else if (pageData[key]) {
      return pageData[key]
    }

    return false
  }

  render() {
    const { t, missingFields, facebookError, googleError, twitterError } = this.props
    const isGdprCompliant = CONSTANTS.SEPARATE_SUBSCRIPTION

    const termsLink = this.generateLinkMarkup(
      this.generateSiteLocaleLink(CONSTANTS.PAGES, CONSTANTS.LOCALE, 'terms_and_conditions'),
      t('TERMS_AND_CONDITIONS'),
    )
    const privacyLink = this.generateLinkMarkup(
      this.generateSiteLocaleLink(CONSTANTS.PAGES, CONSTANTS.LOCALE, 'privacy_policy'),
      t('PRIVACY_POLICY'),
    )

    const termsCopy = isGdprCompliant
      ? t(`${transNamespace()}:TERM_OF_USE`, {terms_and_conditions: termsLink, privacy_policy: privacyLink})
      : t('TERM_OF_USE_WITH_NEWSLETTERS', {terms_and_conditions: termsLink, privacy_policy: privacyLink})

    return (
      <div className="auth-modal xs-py3 xs-px4 xs-col-12">
        <div className="xs-text-3 xs-px5 xs-pb5 xs-text-center">{t('ALMOST_THERE')}</div>

        <form onSubmit={this.completeLogin}>
          { missingFields.indexOf('firstName') > -1 &&
            <div>
              <input
                className={`sign-with xs-py3 xs-fit text-input ${this.state.firstNameError && 'error-input'}`}
                placeholder={t('FIRST_NAME')}
                autoComplete="given-name"
                onChange={this.firstNameHandler}
                onBlur={this.firstNameValidate}
              />
              { this.state.firstNameError !== '' &&
                <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.firstNameError}</span>
              }
            </div>
          }

          { missingFields.indexOf('lastName') > -1 &&
            <div>
              <input
                className={`sign-with xs-py3 xs-fit text-input ${this.state.lastNameError && 'error-input'}`}
                placeholder={t('LAST_NAME')}
                autoComplete="family-name"
                onChange={this.lastNameHandler}
                onBlur={this.lastNameValidate}
              />
              { this.state.lastNameError !== '' &&
                <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.lastNameError}</span>
              }
            </div>
          }

          { missingFields.indexOf('email') > -1 &&
            <div className="xs-mb2">
              <input
                type="email"
                className="sign-with xs-py3 xs-fit text-input"
                placeholder={t('YOUR_EMAIL')}
                autoComplete="email"
                onChange={this.emailHandler}
                required
              />
            </div>
          }

          { facebookError && <span className="xs-block xs-text-red xs-mt1">{facebookError}</span> }
          { googleError && <span className="xs-block xs-text-red xs-mt1">{googleError}</span> }
          { twitterError && <span className="xs-block xs-text-red xs-mt1">{twitterError}</span> }

          { isGdprCompliant &&
            <label className="xs-block xs-mb2" htmlFor="newsletter">
              <input
                type="checkbox"
                id="newsletter"
                className="newsletter-consent check"
                defaultChecked={this.state.hasNewsletterConsent}
                onChange={this.newsletterConsentHandler}
              />
              <span dangerouslySetInnerHTML={{__html: t('NEWSLETTER_CONSENT')}} />
            </label>
          }

          <label className="xs-block xs-mb4" htmlFor="terms">
            <input
              type="checkbox"
              id="terms"
              className="check"
              defaultChecked={this.state.hasTermsConsent}
              onChange={this.termsConsentHandler}
            />
            <span className="terms-consent" dangerouslySetInnerHTML={{__html: termsCopy}} />
            { this.state.termsConsentError !== '' &&
              <span className="error-text">{this.state.termsConsentError}</span>
            }
          </label>

          <button className="xs-fill-blue-cta rounded xs-border-none cond caps xs-text-white xs-py3 xs-col-12" type="submit">
            {t('BUTTON_EMAIL_SIGN_UP')}
          </button>
        </form>
      </div>
    )
  }
}

MoreDetails.propTypes = {
  handleAction: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  missingFields: PropTypes.arrayOf(PropTypes.string),
  clientId: PropTypes.string,
  provider: PropTypes.string,
  providerSecret: PropTypes.string,
  providerToken: PropTypes.string,
  googleError: PropTypes.string,
  twitterError: PropTypes.string,
  facebookError: PropTypes.string,
}

MoreDetails.defaultProps = {
  missingFields: [''],
  clientId: '',
  provider: '',
  providerSecret: '',
  providerToken: '',
  googleError: '',
  twitterError: '',
  facebookError: '',
}



// WEBPACK FOOTER //
// ./src/components/sign-in/more-details.js